const FullHeightLoader = () => {
    return (
        <div className='full-height-loader'>
            <div className='full-height-loader-in'>
                <div className='full-height-loader-box'>
                    <div className='loader'>
                        <div className='round-loader'></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FullHeightLoader;
